export enum ContractType {
    PJ = 1,
    CLT = 2,
    Intern = 3,
    Others = 4
}


// WEBPACK FOOTER //
// ./src/app/shared/enums/ContractType.ts